export const smooth = { lenis: null };
